//Import React Hooks
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';

//MUI :
import Modal from '@mui/material/Modal';
import HelpIcon from '@mui/icons-material/Help';
import LanguageIcon from '@mui/icons-material/Language';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import TutoModal from '../../components/tutomodal/TutoModal.jsx' //<WallyBanner />

//translate
import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../store/selectors.js"; //global state : shopping state
import { langSlice } from "../../store/langSlice.js";
//const lang = useSelector(getLang) //global state : shopping step

function WallyBanner({ size, mode }) {

    let url_image = size === "big" ? 'logo_wally_big.png' : 'logo_wally.png'
    let class_image = size === "big" ? '-img-big' : '-img'

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const location = useLocation();
    const dispatch = useDispatch();
    const lang = useSelector(getLang) //global state : shopping step

    function getStep() {
        let theStep = 1;

        switch (location.pathname) {
            case "/startresa":
                // code block
                theStep = 2;
                break;
            case "/eleves":
                // code block
                theStep = 3;
                break;
            case "/calendar":
                // code block
                theStep = 4;
                break;
            case "/infosclient":
                // code block
                theStep = 5;
                break;
            case "/confirmation":
                // code block
                theStep = 5;
                break;
            default:
                // code block
                theStep = 1;
        }

        return theStep;
    }


    return (
        <section>

            <div className="zebra"></div>

            <div className={mode !== "location" ? "wallybanner" : "wallybanner banner-green"}>
                <img className={"wallybanner" + class_image} src={require("../../images/" + url_image)} alt="logo Wally Glisse" />
                {mode !== "location" ? <span onClick={_ => setOpen(true)}><HelpIcon /></span> : null}
                <div className="wallybanner-lang">
                    <LanguageIcon />
                    <Select
                        sx={{
                            width: 80,
                            height: 30,
                            backgroundColor: '#E0D5B5',
                            marginLeft: '4px',
                            textAlign: 'center',
                            borderRadius: '2px',
                        }}
                        variant="standard"
                        size="small"
                        value={lang}
                        onChange={e => dispatch(langSlice.actions.setLang(e.target.value))}
                    >
                        <MenuItem value={"fr"}>FR</MenuItem>
                        <MenuItem value={"gb"}>ENG</MenuItem>
                    </Select>

                </div>

                <Modal
                    className="home-resa-modal"
                    open={open}
                    onClose={handleClose}
                >
                    <TutoModal toStep={getStep()} handleClose={handleClose} />
                </Modal>

            </div>
        </section>
    );
}

export default WallyBanner;